/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkLcdEnabledRequest} from '../models/BulkLcdEnabledRequest';
import type {BulkLcdEnabledResponse} from '../models/BulkLcdEnabledResponse';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';

export interface EnableLcdSubscriptions$Request {
    bulkLcdEnabledRequest: BulkLcdEnabledRequest;
    reason?: string;
}

export interface EnableLcdSubscriptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enableLcdSubscriptionsRequest = createAction<PayloadData<void, EnableLcdSubscriptions$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS__REQUEST');
export const enableLcdSubscriptionsSuccess = createAction<PayloadData<string, EnableLcdSubscriptions$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS__SUCCESS');
export const enableLcdSubscriptionsFailure = createAction<PayloadData<Error, EnableLcdSubscriptions$Request, true>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS__FAILURE');

export const enableLcdSubscriptionsActions = [
    enableLcdSubscriptionsRequest,
    enableLcdSubscriptionsSuccess,
    enableLcdSubscriptionsFailure
] as const;

/**
 * @param {BulkLcdEnabledRequest} meta.bulkLcdEnabledRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enableLcdSubscriptions = (meta: EnableLcdSubscriptions$Request, config?: EnableLcdSubscriptions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: enableLcdSubscriptionsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/users/enable-lcd-subscriptions`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.bulkLcdEnabledRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface EnableLcdSubscriptionsProgress$Request {
    id: string;
}

export interface EnableLcdSubscriptionsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enableLcdSubscriptionsProgressRequest = createAction<PayloadData<void, EnableLcdSubscriptionsProgress$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS_PROGRESS__REQUEST');
export const enableLcdSubscriptionsProgressSuccess = createAction<PayloadData<BulkProgress, EnableLcdSubscriptionsProgress$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS_PROGRESS__SUCCESS');
export const enableLcdSubscriptionsProgressFailure = createAction<PayloadData<Error, EnableLcdSubscriptionsProgress$Request, true>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS_PROGRESS__FAILURE');

export const enableLcdSubscriptionsProgressActions = [
    enableLcdSubscriptionsProgressRequest,
    enableLcdSubscriptionsProgressSuccess,
    enableLcdSubscriptionsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enableLcdSubscriptionsProgress = (meta: EnableLcdSubscriptionsProgress$Request, config?: EnableLcdSubscriptionsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: enableLcdSubscriptionsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/enable-lcd-subscriptions/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface EnableLcdSubscriptionsResult$Request {
    id: string;
}

export interface EnableLcdSubscriptionsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enableLcdSubscriptionsResultRequest = createAction<PayloadData<void, EnableLcdSubscriptionsResult$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS_RESULT__REQUEST');
export const enableLcdSubscriptionsResultSuccess = createAction<PayloadData<BulkLcdEnabledResponse, EnableLcdSubscriptionsResult$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS_RESULT__SUCCESS');
export const enableLcdSubscriptionsResultFailure = createAction<PayloadData<Error, EnableLcdSubscriptionsResult$Request, true>>('BULK_LCD_SUBSCRIPTION_ENABLE__ENABLE_LCD_SUBSCRIPTIONS_RESULT__FAILURE');

export const enableLcdSubscriptionsResultActions = [
    enableLcdSubscriptionsResultRequest,
    enableLcdSubscriptionsResultSuccess,
    enableLcdSubscriptionsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enableLcdSubscriptionsResult = (meta: EnableLcdSubscriptionsResult$Request, config?: EnableLcdSubscriptionsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: enableLcdSubscriptionsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/enable-lcd-subscriptions`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopSubscriptionEnable$Request {
    id: string;
}

export interface StopSubscriptionEnable$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopSubscriptionEnableRequest = createAction<PayloadData<void, StopSubscriptionEnable$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__STOP_SUBSCRIPTION_ENABLE__REQUEST');
export const stopSubscriptionEnableSuccess = createAction<PayloadData<void, StopSubscriptionEnable$Request>>('BULK_LCD_SUBSCRIPTION_ENABLE__STOP_SUBSCRIPTION_ENABLE__SUCCESS');
export const stopSubscriptionEnableFailure = createAction<PayloadData<Error, StopSubscriptionEnable$Request, true>>('BULK_LCD_SUBSCRIPTION_ENABLE__STOP_SUBSCRIPTION_ENABLE__FAILURE');

export const stopSubscriptionEnableActions = [
    stopSubscriptionEnableRequest,
    stopSubscriptionEnableSuccess,
    stopSubscriptionEnableFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopSubscriptionEnable = (meta: StopSubscriptionEnable$Request, config?: StopSubscriptionEnable$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopSubscriptionEnableActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/enable-lcd-subscriptions`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

